export default __webpack_public_path__ + "static/media/icon-planning-dark.dc52a682.svg";